'use strict';

const Reflux = require('@muzzylane/reflux');
const find = require('lodash/find');
const findIndex = require('lodash/findIndex');
const clone = require('lodash/clone');
const filter = require('lodash/filter');

const Globals = require('../../../app/globals');
const ErrorConsts = require('../constants/error');
const GroupActions = require('../actions/GroupActions');
const SignInActions = require('../actions/sign_in_actions');
const ForgeError = require('../util/error');

let groups = {};
let action = {};
let error = null;
let loading = false;
let group_users = {};

const GroupStore = Reflux.createStore({
    listenables: [GroupActions, SignInActions],
    init: function() {return},

    resetState: function() {
        groups = {};
        // action = {};
        // error = null;
        loading = false;
        group_users = {};
    },
    
    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },    
    
    getState: function() {
        return {
            groups: groups,
            group_users: group_users,
            loading: loading,
            error: error,
            action: action
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
        //error = null;
    },

    onError: function(actionID, err) {
        action.id = actionID;

        if (err.status) {
            switch (err.status) {
                case 400:
                case 404:
                case 403:
                case 406:
                    action.error = new ForgeError({message: err.responseText, stack: null});
                    break;
                    
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null});
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },
    
    onCreateGroupCompleted: function(actionID, newGroup) {
        // console.log("onCreateGroupCompleted: ", actionID, newGroup);
        action = { id: actionID };
        var existingGroup  = find(groups,{ id: String(newGroup.id) });
        if (!existingGroup) {
            groups = groups.concat(newGroup);
        }

        this.emitStatus();
    },

    onCreateGroupFailed: function(actionID, err) {
        console.warn("onCreateGroupFailed: ", actionID, err);
        action = { id: actionID, error: err };
        //todo: parse err.status if required

        this.emitStatus();
    },

    onGetGroupsStarted: function(actionID) {
        loading = true;
        this.emitStatus();
    },

    onGetGroupsCompleted: function(actionID, groupData) {
        action = { id : actionID };
        groups = groupData;
        loading = false;
        this.emitStatus();
    },
    
    onGetGroupsFailed: function(actionID, err) {
        console.warn("onGetGroupsFailed: ", actionID, err);
        groups = [];
        loading = false;
        this.onError(actionID, err);
    },
    
    onArchiveGroupCompleted: function(actionID, group_id, res) {
        // console.log("onArchiveGroupCompleted. actionID=" + actionID + ", group_id=" + group_id);
        action = { id: actionID };
        var index = findIndex(groups,{id:String(group_id)});
        if (index >= 0) {
            groups.splice(index,1); 
            groups = groups.slice(); // clone self 
        }

        this.emitStatus();
    },

    onArchiveGroupFailed: function(actionID, group_id, err) {
        console.warn('onArchiveGroupFailed', actionID, group_id, err);
        this.onError(actionID, err);
    },
   
    onRenameGroupCompleted: function(actionID, params, res) {
        // console.log("onRenameGroupCompleted: ", params, res);
        action = { id: actionID };
        if (res.id && res.name) {
            const group = find(groups, { id: res.id });
            if (group) {
                group.name = res.name;
            }
        }

        this.emitStatus();
    },

    onGetGroupUsersCompleted: function(actionID, params, res) {
        // console.log("onGetGroupUsersCompleted: ", params, res);
        var active_users = res;
        if (active_users) {
            active_users = filter(active_users, {group_status:'ACTIVE'});
        }
        action = {};
        action.id = actionID;
        group_users[params.id] = active_users;
        this.emitStatus();
    },
    
    onGetGroupUsersFailed: function(actionID, params, err) {
        console.warn("onGetGroupUsersFailed: ", actionID, err);
        delete group_users[params.id];
        this.onError(actionID, err);
    },
    
    onInviteGroupUserCompleted: function(actionID, params,res) {
        // console.log("onInviteGroupUserCompleted.",actionID, params, res);
        action = {};
        action.id = actionID;
        var users = group_users[params.group_id];
        if (users) {
            var index = findIndex(users,{id: res.id});
            if (index >= 0) {
                users[index] =  res;
            }
            else {
                users.push(res);
            }
        }
        this.emitStatus();
    },
   
    onInviteGroupUserFailed: function(actionID, params, err) {
        console.warn("onInviteGroupUserFailed: ", actionID, err);
        this.onError(actionID, err);
    },

    onRemoveGroupUserCompleted: function(actionID, params, res) {
        // console.log("onRemoveGroupUserCompleted.",actionID, params, res);
        action = { id: actionID };
        var users = group_users[params.group_id];
        if (users) {
            var index = findIndex(users,{hash: params.user_hash});
            if (index >= 0) {
                users.splice(index,1);
                group_users[params.group_id] = clone(users);
                group_users = clone(group_users); // change object
            }
        }
        this.emitStatus();
    },
   
    onRemoveGroupUserFailed: function(actionID, params, err) {
        console.warn("onRemoveGroupUserFailed: ", actionID, err);
        this.onError(actionID, err);
    },    
});

module.exports = GroupStore;
